import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { File, ISchedule } from '../../../../shared/models/schedule';
import { CommonModule, DatePipe } from '@angular/common';
import { Icons } from '../../../../shared/helpers/icons';
import { LucideAngularModule } from 'lucide-angular';
import { FilesService } from '../../../../shared/services/files.service';
import { IUserInfo } from '../../../../shared/models/contact';
import { UserDataService } from '../../../../shared/services/userData.service';
import { SpinnerComponent } from '../../../components/spinner/spinner.component';

@Component({
  selector: 'event-details',
  standalone: true,
  imports: [
    CommonModule,
    LucideAngularModule,
    SpinnerComponent
  ],
  providers: [DatePipe],
  templateUrl: './event-details.component.html',
  styleUrl: './event-details.component.css'
})
export class EventDetailsComponent implements OnInit {
  icons = Icons;
  formattedStartDate: string | null = null;
  formattedEndDate: string | null = null;
  currentUser: IUserInfo | null = null;

  loading: boolean = false;

  @Input() eventDetails: ISchedule | null = null;
  
  @Output() onClose = new EventEmitter<void>();
  @Output() onOpenModal = new EventEmitter<{ modalName: string, selectedItem: ISchedule, itemType?: string }>();

  constructor(
    private datePipe: DatePipe,
    private filesService: FilesService,
    private userDataService: UserDataService
  ) {}

  ngOnInit(): void {
    this.currentUser = this.userDataService.getUserData();
    if (this.eventDetails?.start_date) {
      this.formattedStartDate = this.dateTypeToDisplay(this.eventDetails?.start_date);
      this.formattedEndDate = this.dateTypeToDisplay(this.eventDetails?.end_date); 
      if (this.formattedStartDate) {
        this.eventDetails.start_date = this.formattedStartDate;
      } else {
        console.error('unsuccess to format start_date');
      }
      if (this.formattedEndDate) {
        this.eventDetails.end_date = this.formattedEndDate;
      } else {
        console.error('unsuccess to format end_date');
      }
    }   
  }
  
  downloadFile(file: File): void {
    this.loading = true;
    this.filesService.downloadFile(String(file.building_id), String(file.section_id), file.id).subscribe({
      next: (res) => {
        this.loading = false;
        if (!res.has_error && res.data?.signed_url) {
          window.open(res.data.signed_url, '_blank');
        } else {
          console.error('Error downloading file:', res.message);
        }
      },
      error: (err) => {
        this.loading = false;
        console.error('Download failed:', err);
      }
    });
  }


  closeDetails(): void {
    this.onClose.emit();
  }
  
  canSave(): boolean {
    if (!this.currentUser) return false;
    return this.currentUser.can_edit || this.currentUser.can_admin;
  }

  handleBtnClick(modalName: string, selectedItem: any, itemType?: string): void {
    this.onOpenModal.emit({ modalName, selectedItem, itemType });
  }

  dateTypeToDisplay(date: any): string | null {
    return this.datePipe.transform(date, 'yyyy-MM-dd');
  }
}
